import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { About } from './components/About';
import { Services } from './components/Services';
import { FeaturedProjects } from './components/FeaturedProjects';
import { Work } from './components/Work';
import { WhyPureBuild } from './components/WhyPureBuild';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { CtaBanner } from './components/CtaBanner';
import { Location } from './components/Location';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { ChatWidget } from './components/ChatWidget';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="28ufnm9e7hai0">
      <Header data-id="element-1" data-mp="28te2fc3h77mk" />
      <main data-id="element-2" data-mp="28sutulzptvl7">
        <Hero data-id="element-3" data-mp="28sl5t3y8dyi5" />
        <TrustBar data-id="element-4" data-mp="28s2zfehuu3wi" />
        <About data-id="element-5" data-mp="23vkuoemiy5k6" />
        <Services data-id="element-6" data-mp="23w4g45bdvc2y" />
        <FeaturedProjects data-id="element-7" data-mp="23ujmchww7x65" />
        <Work data-id="element-8" data-mp="23t8iki3g6pf1" />
        <WhyPureBuild data-id="element-9" data-mp="3ijxpcqos80jw" />
        <Process data-id="element-10" data-mp="3ikhaeg9qb525" />
        <Testimonials data-id="element-11" data-mp="3iiwfgpji5k3r" />
        <CtaBanner data-id="element-12" data-mp="3ijpbowku4r7n" />
        <Location data-id="element-13" data-mp="3ii4sg33z0up3" />
        <Contact data-id="element-14" data-mp="3mlavz2zp87rv" />
      </main>
      <Footer data-id="element-15" data-mp="3mkhmvvd9p66k" />
      <ChatWidget data-id="element-16" data-mp="3mjzs7369700r" />
    </div>;
}